/**
 * Order Socket Context - Folder wrapper
 *
 * This wraps the shared SDK OrderSocketProvider with app-specific configuration.
 * All the socket logic is in @ygoargentina/sdk/contexts/order-socket-context
 */
import { type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { handleSessionChanged } from '@ygoargentina/sdk/api/session-changed';
import {
  OrderSocketProvider as SDKOrderSocketProvider,
  useOrderSocket,
  useOrderRoom,
} from '@ygoargentina/sdk/contexts/order-socket-context';
import { useAuth } from './Auth';
import Config from '@/config';
import packageJson from '../../package.json';

export function OrderSocketProvider({ children }: { children: ReactNode }) {
  const { user, refreshUser } = useAuth();
  const queryClient = useQueryClient();

  // Cambió su staff: la sesión nueva y, si cambió algo, lo que dependía de
  // ella (las listas de organizadores las filtra el API por membresía).
  const onSessionChanged = () =>
    void handleSessionChanged(queryClient, refreshUser);

  return (
    <SDKOrderSocketProvider
      wsUrl={Config.wsUrl}
      userId={user?.id}
      appName="folder"
      appVersion={packageJson.version}
      onSessionChanged={onSessionChanged}
    >
      {children}
    </SDKOrderSocketProvider>
  );
}

// Re-export hooks from SDK
export { useOrderSocket, useOrderRoom };
